// extracted by mini-css-extract-plugin
export default {"KeywordCell":"KeywordCell_KeywordCell__TkubI","KeywordValue":"KeywordCell_KeywordValue__Rn0Yr"};